// adpated from: https://github.com/Roberson-Andrade/tiptap-playground/tree/master/detect-mention-deleting

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import getCallMeBy from '@/components/user/get-call-me-by';
import { cn } from '@/lib/utils';
import { userStore } from '@/models/stores';
import type { NodeViewProps } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import { observer } from 'mobx-react';
import ProfileCard from '../profile-card';

const MentionComponent = observer((props: NodeViewProps) => {
  const users = userStore.all;
  const id = props.node.attrs.id;
  const user = users.find((user) => user.id === id);

  return (
    user && (
      <NodeViewWrapper className="inline w-fit" as="span">
        <Tooltip>
          <TooltipTrigger className="inline-flex w-fit flex-row items-center gap-0">
            <span
              className={cn(
                'rounded bg-custom-primary-100/20 px-0 py-0.5 font-semibold text-custom-primary-100',
              )}
            >
              @{user && getCallMeBy(user)}
            </span>
          </TooltipTrigger>
          <TooltipContent>
            <ProfileCard user={user} />
          </TooltipContent>
        </Tooltip>
      </NodeViewWrapper>
    )
  );
});

export default MentionComponent;
